import { useEffect, useRef, useState } from "react";
import { getStoreLogoUrlAPI } from "../../../utils/api/ludDashboard";

// Logo URL of the given store. Always describes the store passed in: switching
// stores clears the previous logo immediately, and a late answer for a store
// that is no longer selected is ignored. Each store is fetched once.
export default function useStoreLogo(storeId) {
  const cache = useRef(new Map());
  const [logo, setLogo] = useState({ storeId: "", url: "" });

  useEffect(() => {
    const token = localStorage.getItem("auth-token");
    if (!token || !storeId) return undefined;
    if (cache.current.has(storeId)) {
      setLogo({ storeId, url: cache.current.get(storeId) });
      return undefined;
    }

    let cancelled = false;
    getStoreLogoUrlAPI(token, storeId)
      .then((res) => res.url || "")
      .catch(() => "")
      .then((url) => {
        if (cancelled) return;
        cache.current.set(storeId, url);
        setLogo({ storeId, url });
      });
    return () => {
      cancelled = true;
    };
  }, [storeId]);

  return { url: logo.storeId === storeId ? logo.url : "", loading: logo.storeId !== storeId };
}
